// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"fb54576b","372":"cb199af6","592":"7acb4264","732":"e02a5398","856":"932f9453"}[chunkId] + ".chunk.js";
};